import React, { Fragment, useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { connect } from "react-redux";
import {
  getDevice,
  getDeviceUsagebyId,
  getFirmwareHistory,
  getOnboardedHistory,
  getDiagnosticsData,
} from "../../action/report";
import { getUserById, clearUserById } from "../../action/user";
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import { getWarrantyInfo, clearWarrantyData } from "../../action/warranty";
import Alert from "../layout/Alert";
import ResponsiveContentWrapper from "../layout/ResponsiveContentWrapper";
import DeviceDetails from "../device/DeviceDetails";
import UserInfo from "../dashboard//UserInfo";
import customConfig from "../../config";
import { selectMenuProps } from "../../utils/selectMenuProps";
import BarcodeScanner from "../Common/scanner/BarcodeScanner";
import { getQRDetailsUsingScanner } from "../../action/qrcode";
import { setAlert } from "../../action/alert";
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import DeviceUpdateLogs from "./DeviceUpdateLogs";
import DeviceDiagnostics from "./DeviceDiagnostics/DeviceDiagnostics";
import DeviceConnDisconnLogs from "./DeviceConnDisconn/DeviceConnDisconnLogs";
import { downloadDeviceDiagnosticReport, downloadDeviceStatusReport, getDeviceConnDisconnLogsData, getDeviceDACLogsData, getDeviceDiagnosticsData, getDeviceStatusData } from "../../action/devicelogs";
import DeviceStatus from "./DeviceStatus/DeviceStatus";
import { getFormatedJSON } from "../../utils/general";
import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import { getDeviceLogPermission } from "./DeviceLogsConstants";
import DeviceDACLogs from "./DACStatistics/DeviceDACLogs/DeviceDACLogs";
import "../Common/searchFilterLayout.css";

const activeTabSx = { border: '1px solid #bdbdbd', backgroundColor: '#e0e0e0', color: '#333333', textTransform: 'capitalize' };
const nonActiveTabSx = { border: 'none', backgroundColor: 'none', color: '#333333', textTransform: 'capitalize' };
const tabContainerSx = { "& .MuiTabs-fixed": { overflow: 'auto !important', width: '100%' } };
const dialogSx = (theme) => ({
  zIndex: "2400 !important",
  "& .MuiDialogTitle-root": { backgroundColor: "#f4f4f4", "& h2": { fontSize: "16px !important" } },
  "& .MuiDialogContent-root": {
    padding: "24px",
    [theme.breakpoints.down('sm')]: { minWidth: "100%", maxWidth: "100%", padding: "16px" },
    minWidth: "800px",
    maxWidth: "800px"
  },
  "& .buttonContainer": { display: "flex", justifyContent: "flex-end", marginTop: "16px" },
  "& .MuiDialog-paperWidthSm": {
    maxWidth: "800px",
    [theme.breakpoints.down('sm')]: { margin: 8, maxWidth: "calc(100% - 16px)" },
  },
  "& .dialogContents": {
    maxWidth: "800px",
    minHeight: "280px",
    maxHeight: "240px",
    overflowY: "auto",
    [theme.breakpoints.down('sm')]: { maxWidth: "100%" },
  },
});

const SearchDevice = ({
  setAlert,
  deviceId,
  getDevice,
  getDeviceUsagebyId,
  getFirmwareHistory,
  getUserById,
  clearUserById,
  getOnboardedHistory,
  getWarrantyInfo,
  clearWarrantyData,
  getDiagnosticsData,
  getDeviceDiagnosticsData,
  downloadDeviceDiagnosticReport,
  getDeviceConnDisconnLogsData,
  getDeviceStatusData,
  getDeviceDACLogsData,
  downloadDeviceStatusReport,
  DeviceData: {
    device,
    deviceUsage,
    latestFirmwareData,
    firmwareData,
    onBoardedHistoryData,
    diagnosticData,
    deviceLogs,
    report
  },
  UserData: { userById },
  // Use responsive wrapper for all states; avoid legacy fixed-width class
  wrapperClass = "",
  searchBarWrapperClass = "",
  userRoleInfo,
  tenantInfo,
  /** When true, skip ResponsiveContentWrapper - used when embedded (e.g. inside ManufacturedDevices) */
  embedded = false,
  /** Optional content to render before the search block - e.g. Back button for aligned layout */
  prependContent,
}) => {
  const tabs = [{ label: 'Device Info', permission: "deviceInfo" }, { label: "DAC Logs", permission: "dacLogs" }, { label: "Device Logs", permission: 'deviceLogs' }, { label: "Connection Status Logs", permission: "connectionStatusLogs" }, { label: "Diagnostic Logs", permission: "diagnosticLogs" }, { label: "Status Logs", permission: "statusLogs" }]
  const theme = useTheme();
  const [activeTab, setActiveTab] = React.useState(0)

  const location = useLocation();
  const searchInitiated = useRef(false);
  const [text, setText] = useState("");
  const [showText, setShowText] = useState(false);
  const [searchBy, setSearchBy] = useState(customConfig.deviceSearchByDeviceId);
  const [searchByPlaceHolder, setSearchByPlaceHolder] =
    useState("Enter Device Id");
  const [withoutOnboard, setWithoutOnboard] = useState(false);

  const [displayScanner, setDisplayScanner] = useState(false);
  const [dialog, setDialog] = useState(false);
  const [dialogContents, setDialogContents] = useState({ title: '', data: {} });
  const [availableTabs, setAvailableTabs] = React.useState([]);
  const [selectedTab, setSelectedTab] = React.useState(availableTabs[0]);

  useEffect(() => {
    if (deviceId) {
      clearUserById();
      setText(deviceId);
      setShowText(false);
      setWithoutOnboard(false);
      device = null;
      searchInitiated.current = true;
      getDevice(deviceId, customConfig.deviceSearchByDeviceId, userRoleInfo, tenantInfo.tenantId);
    }
    else {
      if (!showText && location.state) {
        setShowText(true);
      }
    }
  }, []);

  useEffect(() => {
    const visibleTabs = tabs?.filter(t => {
      return getDeviceLogPermission(userRoleInfo?.roles, t?.permission)
    })?.map(t => t?.label)
    setAvailableTabs(visibleTabs)
    setSelectedTab(visibleTabs[0])
  }, [userRoleInfo?.roles])

  useEffect(() => {
    if (text.length > 0 && device && device.length > 0) {
      const userId = device[0].onboardedById;

      if (!(userRoleInfo.level===0 && userRoleInfo.roles.includes(customConfig.roleFactoryAdmin))) {
        if (userId && userId.length > 0) {
          getUserById(userId, tenantInfo.tenantId);
        } else {
          setWithoutOnboard(true);
        }
      }

      const devId = device[0].deviceId;

      if (!(userRoleInfo.level===0 && userRoleInfo.roles.includes(customConfig.roleFactoryAdmin))) {
        getFirmwareHistory(devId);
        getOnboardedHistory(devId);
        getDiagnosticsData(devId);
        getDeviceUsagebyId(devId);
      }

      setShowText(true);
      setText("");
    }
  }, [device]);

  useEffect(() => {
    if (searchInitiated.current) {
      // Get eWarranty auth token and Product List
      if (userById && userById.mobile) {
        getWarrantyInfo(userById.mobile);
      } else {
        clearWarrantyData();
      }
    }
  }, [userById]);

  const onSubmit = (e) => {
    e.preventDefault(true);
    setActiveTab(0)
    clearUserById();
    setShowText(false);
    setWithoutOnboard(false);
    device = null;
    searchInitiated.current = true;
    getDevice(text, searchBy, userRoleInfo, tenantInfo.tenantId);
  };

  const onChange = (e) => setText(e.target.value);

  const searchByLabels = {
    [customConfig.deviceSearchByDeviceId]: "Device Id",
    [customConfig.deviceSearchByMacAddress]: "Mac Address",
    [customConfig.deviceSearchByProductSerialNumber]: "Product Serial No.",
  };
  const changeSearchBy = (e) => {
    const value = e.target.value;
    setSearchBy(value);
    setText("");
    setSearchByPlaceHolder(`Enter ${searchByLabels[value] || value}`);
    device = {};
    setShowText(false);
  };

  const handleNotifyOffboard = () => {
    setShowText(false);
  };

  function handleScanQRcodeAndBarcode() {
    setDisplayScanner(!displayScanner)
  }

  function handleQRCodeScanDetails(data) {
    clearUserById();
    setShowText(false);
    setWithoutOnboard(false);
    device = null;

    if (data.toString().substring(0, 2)==="MT") {
      //qrcode
      getQRDetailsUsingScanner(data)
        .then((qrCodeScannedResult) => {
          if (qrCodeScannedResult.productSerialNumber) {
            setText(qrCodeScannedResult.productSerialNumber)
            getDevice(qrCodeScannedResult.productSerialNumber, customConfig.deviceSearchByProductSerialNumber, userRoleInfo, tenantInfo.tenantId)
          }
          else {
            setAlert("Cannot Scan QR Code. Scanned QR Code is Model ID Based QR Code", "danger")
          }

        })
        .catch((error) => {
          setAlert("Failed to Scan QR Code", "danger")
        })
    }
    else {
      // scanned data is product serial number using barcode
      setText(data)
      getDevice(data, customConfig.deviceSearchByProductSerialNumber, userRoleInfo, tenantInfo.tenantId);
    }
  }

  const content = (
    <Fragment>
      <ResponsiveContentWrapper className={wrapperClass || ""} noTopMargin={!!deviceId}>
        <div className={`search-device-page-container ${wrapperClass} ${deviceId ? 'embedded-search-device' : ''}`}>
          <div className="container">
          <Grid container spacing={{ xs: 0, sm: 2 }}>
            <Grid item xs={12}>
              <div className="content-block bottom-shadow mb-0 search-filter-block search-filter-united-field">
                <div className="row">
                  <div className="s12 col no-side-padding">
                    <div className="content-block bottom-shadow mb-0">
                      <div className="p-15">
                        <div className="search-filter-filter">
                          <div className="search-filter-title">
                            <span className="black-text font-600">Search Device</span>
                          </div>
                          <div className="search-filter-controls">
                            <span className="search-filter-search-by">Search By</span>
                            <FormControl variant="outlined" size="small" className="search-filter-type-select">
                              <Select
                                name="searchBy"
                                value={searchBy}
                                onChange={(e) => changeSearchBy(e)}
                                MenuProps={selectMenuProps}
                              >
                                <MenuItem value={customConfig.deviceSearchByDeviceId}>Device Id</MenuItem>
                                <MenuItem value={customConfig.deviceSearchByMacAddress}>Mac Address</MenuItem>
                                <MenuItem value={customConfig.deviceSearchByProductSerialNumber}>Product Serial No.</MenuItem>
                              </Select>
                            </FormControl>
                            <form className="search-filter-form" onSubmit={onSubmit}>
                              <div className="search-filter-input-wrap">
                                <div className="search-device not-found right">
                                  <i className="material-icons search-icon"> search</i>
                                  <input
                                    className="add-input notransform border-0"
                                    placeholder={searchByPlaceHolder}
                                    type="text"
                                    name="text"
                                    value={text}
                                    onChange={onChange}
                                  />
                                </div>
                              </div>
                              <div className="search-filter-btn">
                                <input
                                  type="submit"
                                  value="Search"
                                  className="btn orange-bg btn-block md no-shadow"
                                />
                              </div>
                            </form>
                            <div className="search-filter-scan search-filter-scan-inline">
                              <i
                                className="fa fa-qrcode fa-qrcode-search-device"
                                aria-hidden="true"
                                onClick={() => handleScanQRcodeAndBarcode()}
                                title="Click to Scan QR Code or Barcode"
                              />
                            </div>
                          </div>
                        </div>
                        {displayScanner && (
                          <div style={{ marginTop: 16 }}>
                            <BarcodeScanner scanDetailsHandler={handleQRCodeScanDetails} />
                            <label>QR Code or Barcode Scanner</label>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
          </div>
          <div className="mid-seprator"></div>
          <Alert />
        <div>
        {showText && device && Object.keys(device).length > 0 && (
          <div
            style={{ marginTop: "0px", paddingTop: "0px", width: "100%", minWidth: 0 }}
            className={wrapperClass}
          >
            <div className="container">
              <div className="content-block bottom-shadow py-15 mb-30 device-detail-wrap device-info">
                {!(userRoleInfo.level===0 && userRoleInfo.roles.includes(customConfig.roleFactoryAdmin)) &&
                  (userById || withoutOnboard) && (
                    <div className="row mb-0">
                      <UserInfo
                        user={userById}
                        withoutOnboard={withoutOnboard}
                      ></UserInfo>
                    </div>
                  )
                }
                <Box sx={tabContainerSx}>
                  <Tabs
                    value={activeTab}
                    onChange={(e, newValue) => {
                      setActiveTab(newValue)
                      setSelectedTab(availableTabs[newValue])
                    }}
                    TabIndicatorProps={{
                      style: {
                        backgroundColor: "#bdbdbd",
                        float: 'right'
                      }
                    }}
                    style={{ marginTop: '20px' }}
                  >
                    {availableTabs?.map((t) => <Tab key={t} label={t} sx={selectedTab === t ? activeTabSx : nonActiveTabSx} style={{ border: '1px solid black' }} />)}
                  </Tabs>
                </Box>

                {
                  (() => {
                    switch (selectedTab) {
                      case "Device Info":
                        return <div className="device-info-tab-content">
                          <div className="row mb-0">
                            <div className="s12 p-0 col">
                              <div className="content-block position-relative">
                                <div className="p-15">
                                  <DeviceDetails
                                    device={device}
                                    deviceUsage={deviceUsage}
                                    latestFirmwareData={latestFirmwareData}
                                    firmwareData={firmwareData}
                                    onBoardedHistoryData={onBoardedHistoryData}
                                    diagnosticData={diagnosticData}
                                    notifyOffboard={handleNotifyOffboard}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      case "DAC Logs":
                        return <DeviceDACLogs
                          getDeviceDACLogsData={getDeviceDACLogsData}
                          dacData={deviceLogs}
                          deviceDetails={device ? device.length > 1 ? device[1] : device[0] : {} ?? {}}
                        />
                      case "Device Logs":
                        return <DeviceUpdateLogs
                          deviceDetails={device ? device.length > 1 ? device[1] : device[0] : {} ?? {}}
                        />
                      case "Connection Status Logs":
                        return <DeviceConnDisconnLogs
                          connectionStatusLogs={deviceLogs}
                          getDeviceConnDisconnLogsData={getDeviceConnDisconnLogsData}
                          deviceDetails={device ? device.length > 1 ? device[1] : device[0] : {} ?? {}}
                        />
                      case "Diagnostic Logs":
                        return <DeviceDiagnostics
                          setDialog={setDialog}
                          setDialogContents={setDialogContents}
                          diagnosticData={deviceLogs}
                          deviceDetails={device ? device.length > 1 ? device[1] : device[0] : {} ?? {}}
                          getDeviceDiagnosticsData={getDeviceDiagnosticsData}
                          downloadDeviceDiagnosticReport={downloadDeviceDiagnosticReport}
                        />
                      case "Status Logs":
                        return <DeviceStatus
                          setDialog={setDialog}
                          setDialogContents={setDialogContents}
                          statusData={deviceLogs}
                          deviceDetails={device ? device.length > 1 ? device[1] : device[0] : {} ?? {}}
                          getDeviceStatusData={getDeviceStatusData}
                          downloadDeviceStatusReport={downloadDeviceStatusReport}
                        />
                    }
                  })()
                }
              </div>
          </div>
        </div>
        )}
        </div>
        </div>
      </ResponsiveContentWrapper>
        <Dialog
        sx={dialogSx(theme)}
        open={dialog}
        TransitionProps={{ timeout: 300 }}
        slotProps={{ backdrop: { TransitionProps: { timeout: 300 } } }}
      >
        <DialogTitle>
          {dialogContents?.title}
        </DialogTitle>
        <DialogContent>
          <div className="dialogContents">
            {getFormatedJSON(dialogContents?.data)}
          </div>
          <div className="buttonContainer grey-theme">
            <button
              style={{ marginLeft: "8px", }}
              className="btn btn-style-2 dark-text gray-bg"
              onClick={(e) => { setDialog(false) }}
            >
              Close
            </button>
          </div>
        </DialogContent>
        </Dialog>
    </Fragment>
  );

  return content;
};

const mapStateToProps = (state) => ({
  DeviceData: state.report,
  UserData: state.user,
  userRoleInfo: {
    level: state.auth.userLevel,
    roles: state.auth.userRoles,
  },
  tenantInfo: state.tenant.tenantInfo,
});

const mapDispatchToProps = (dispatch) => ({
  getDevice: (arg1, arg2, arg3, arg4, arg5) => dispatch(getDevice(arg1, arg2, arg3, arg4, arg5)),
  getDeviceUsagebyId: (arg1) => dispatch(getDeviceUsagebyId(arg1)),
  getFirmwareHistory: (arg1) => dispatch(getFirmwareHistory(arg1)),
  getOnboardedHistory: (arg1) => dispatch(getOnboardedHistory(arg1)),
  getUserById: (arg1, arg2, arg3) => dispatch(getUserById(arg1, arg2, arg3)),
  clearUserById: () => dispatch(clearUserById()),
  getWarrantyInfo: (arg1) => dispatch(getWarrantyInfo(arg1)),
  clearWarrantyData: () => dispatch(clearWarrantyData()),
  getDiagnosticsData: (arg1) => dispatch(getDiagnosticsData(arg1)),
  setAlert: (message, status) => dispatch(setAlert(message, status)),
  getDeviceConnDisconnLogsData: (deviceId, cb) => { dispatch(getDeviceConnDisconnLogsData(deviceId, cb)) },
  getDeviceDiagnosticsData: (params, cb) => { dispatch(getDeviceDiagnosticsData(params, cb)) },
  getDeviceDACLogsData: (params, cb) => { dispatch(getDeviceDACLogsData(params, cb)) },
  downloadDeviceDiagnosticReport: (params, cb) => { dispatch(downloadDeviceDiagnosticReport(params, cb)) },
  getDeviceStatusData: (params, cb) => { dispatch(getDeviceStatusData(params, cb)) },
  downloadDeviceStatusReport: (params, cb) => { dispatch(downloadDeviceStatusReport(params, cb)) }

})

export default connect(mapStateToProps, mapDispatchToProps)(SearchDevice);
